module.exports = __webpack_public_path__ + "static/img/mg1.410e5dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mg1.png
// module id = CarO
// module chunks = 3